<bspk-toggle-option [description]="description()" [label]="label()">
  <bspk-checkbox [aria-label]="label()"
                 [attr.aria-description]="description() ?? null"
                 [checked]="checked()"
                 [disabled]="disabled()"
                 [indeterminate]="indeterminate()"
                 [readOnly]="readOnly()"
                 (blur)="onTouched()"
                 (checkedChange)="handleChange($event)"
  />
</bspk-toggle-option>
